import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { AIChatButton } from './AIChatButton';
import { AIChatWindow } from './AIChatWindow';
import { DelayedFeedbackBanner } from './DelayedFeedbackBanner';
import { useAIChat } from '@/hooks';
import { fieldUpdateHandler } from '@/state/aiChat';
/**
 * Main AI Chat Widget component
 * Displays a floating button and chat window
 */
export const AIChatWidget = ({ contextBuilder, hasNotification = false, }) => {
    const { state, toggleChat, closeChat, minimizeChat, maximizeChat, sendUserMessage, applyToField, executeAction, provideFeedback, provideMessageFeedback, hideDelayedFeedback, } = useAIChat();
    const handleToggleChat = () => {
        toggleChat(contextBuilder);
    };
    const resolveMessage = (messageId) => state.messages.find(m => m.id === messageId);
    const handleSelectVariation = async (messageId, variationIndex, value) => {
        const message = resolveMessage(messageId);
        const targetField = message?.targetFieldName;
        if (!targetField || !fieldUpdateHandler.value)
            return false;
        await applyToField(targetField, value, variationIndex, message?.backendIndex);
        return true;
    };
    const handleSelectAllVariations = async (messageId, variations) => {
        const message = resolveMessage(messageId);
        const targetField = message?.targetFieldName;
        if (!targetField || !fieldUpdateHandler.value)
            return false;
        await applyToField(targetField, JSON.stringify(variations), undefined, message?.backendIndex);
        return true;
    };
    return (_jsxs("div", { className: "ai-chat-widget", children: [!state.isOpen && (_jsx(AIChatButton, { onClick: handleToggleChat, hasNotification: hasNotification })), _jsx(AIChatWindow, { state: state, onClose: closeChat, onMinimize: minimizeChat, onExpand: maximizeChat, onSendMessage: sendUserMessage, onSelectVariation: handleSelectVariation, onSelectAllVariations: handleSelectAllVariations, onExecuteAction: executeAction, onProvideFeedback: provideFeedback, onMessageFeedback: provideMessageFeedback }), state.showDelayedFeedback && (_jsx(DelayedFeedbackBanner, { onRate: (rating) => {
                    provideFeedback(rating);
                    hideDelayedFeedback();
                } }))] }));
};
